import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';

import { DashboardComponent } from './dashboard/dashboard.component';
import { AccountsComponent } from './accounts/accounts.component';
import { AgencysComponent } from './agencys/agencys.component';
import { IntegrationsComponent } from './integrations/integrations.component';
import { TrackerTagComponent } from './tracker-tag/tracker-tag.component';

import { ReportsComponent } from './reports/reports.component';
import { LoginComponent } from './login/login.component';
import { UserPreferencesComponent } from './user-preferences/user-preferences.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ForgotPasswordConfirmationComponent } from './forgot-password-confirmation/forgot-password-confirmation.component';
import {
  ReportCampaignsGoogleComponent
} from "./report-components/report-campaigns-google/report-campaigns-google.component";
import { ReportCampaignsFacebookComponent } from './report-components/report-campaigns-facebook/report-campaigns-facebook.component';
import { ReportActionsComponent } from './report-components/report-actions/report-actions/report-actions.component';
import { ReportActionsPagingComponent } from './report-components/report-actions-paging/report-actions-paging.component';

import { ReportJourneyComponent } from './report-components/report-journey/report-journey.component';
import { ReportAttributionComponent } from './report-components/report-attribution/report-attribution.component';
import { IntegrationsRedirectComponent } from './integrations-redirect/integrations-redirect.component';
import { IntegrationsGoogleadsComponent } from './integrations-providers/integrations-googleads/integrations-googleads.component';
import { IntegrationsClickfunnelsComponent } from './integrations-providers/integrations-clickfunnels/integrations-clickfunnels.component';
import { IntegrationFacebookComponent } from './integrations-providers/integration-facebook/integration-facebook.component';
import { IntegrationsShopifyComponent } from './integrations-providers/integrations-shopify/integrations-shopify.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login',  component: LoginComponent},
  { path: 'dashboard/:agency_id/:account_id',  component: DashboardComponent, canActivate: [AuthGuard]},
  { path: 'user/preferences',  component: UserPreferencesComponent, canActivate: [AuthGuard]},
  { path: 'user/password',  component: ChangePasswordComponent, canActivate: [AuthGuard]},
  { path: 'forgot-password',  component: ForgotPasswordComponent},
  { path: 'forgot-password-confirmation',  component: ForgotPasswordConfirmationComponent},
  { path: 'accounts/:agency_id',  component: AccountsComponent, canActivate: [AuthGuard]},
  { path: 'agencys',  component: AgencysComponent, canActivate: [AuthGuard]},
  { path: 'integrations/:agency_id/:account_id',  component: IntegrationsComponent, canActivate: [AuthGuard]},
  { path: 'integrations/providers/googleads/:agency_id/:account_id',  component: IntegrationsGoogleadsComponent, canActivate: [AuthGuard]},
  { path: 'integrations/providers/facebook/:agency_id/:account_id',  component: IntegrationFacebookComponent, canActivate: [AuthGuard]},
  { path: 'integrations/providers/clickfunnels/:agency_id/:account_id',  component: IntegrationsClickfunnelsComponent, canActivate: [AuthGuard]},
  { path: 'integrations/providers/shopify/:agency_id/:account_id',  component: IntegrationsShopifyComponent, canActivate: [AuthGuard]},
  { path: 'integrations-redirect',  component: IntegrationsRedirectComponent},

  { path: 'trackertag/:agency_id/:account_id',  component: TrackerTagComponent, canActivate: [AuthGuard]},
  { path: 'reports',  component: ReportsComponent, canActivate: [AuthGuard]},

  { path: 'agency/account/reports/:agency_id/:account_id',  component: ReportsComponent ,canActivate: [AuthGuard],  children: [
      { path: 'campaigns/google/:agency_id/:account_id',  component: ReportCampaignsGoogleComponent , canActivate: [AuthGuard], outlet:"report"},
      { path: 'campaigns/facebook/:agency_id/:account_id',  component: ReportCampaignsFacebookComponent , canActivate: [AuthGuard], outlet:"report"},
      { path: 'campaigns/actions/:agency_id/:account_id',  component: ReportActionsComponent , canActivate: [AuthGuard], outlet:"report"},
      { path: 'campaigns/actions-paging/:agency_id/:account_id',  component: ReportActionsPagingComponent , canActivate: [AuthGuard], outlet:"report"},
      { path: 'campaigns/journey/:agency_id/:account_id/:auid',  component: ReportJourneyComponent , canActivate: [AuthGuard], outlet:"report"},
      { path: 'campaigns/attribution/:agency_id/:account_id',  component: ReportAttributionComponent , canActivate: [AuthGuard], outlet:"report"},
      // { path: 'control/etf/:agency_id/:account_id',  component: ReportEtfControlChartsComponent , canActivate: [AuthGuard], outlet:"report"},
      // { path: 'asset/ohlcv',  component: ReportAssetOhlcvChartsComponent  , canActivate: [AuthGuard], outlet:"report"},
      // { path: 'crypto/ohlcv',  component: ReportCryptoOhlcvChartsComponent , canActivate: [AuthGuard], outlet:"report"},
      // { path: 'crypto/sentimentvolume',  component:  ReportCryptoSentimentVolumeComponent , canActivate: [AuthGuard], outlet:"report"},
      // { path: 'crypto/wordcloud',  component:  ReportSentimentWordcloudComponent , canActivate: [AuthGuard], outlet:"report"},
      // { path: 'campaign/gantt/:account_id',  component:  RepoprtCampaignsGanttComponent , canActivate: [AuthGuard], outlet:"report"},
      // { path: 'campaign/performance/:account_id',  component:  ReportCampaignPerformanceComponent , canActivate: [AuthGuard], outlet:"report"},
    ]},



];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
